VP = window.VP || {};
VP_storyTracker_data = window.VP_storyTracker_data || {};

(function( $, waypoint ) {
  VP.storyTracker = {
    resfreshtimer:null,
    lastheight:0,
    enabled: false,
    expanded: false,
    expandformobile: false,
    infotimer: null,
    infowindow: null,
    infowindowclosetimeout: 500,
    lastclicked: null,
    delayonce: true,
    userlocset: false,
    hasuserlocation:false,
    userlat:"",
    userlng:"",
    userpos:null,
    usermarker:null,
    isEngaged: false,
    bubblelinktext: "<div class='bubblelink mobilemaponly'>Read More</div>",
    map: {

      bounds: null,
      element: null,
      obj: null,
      style: null,
      single_item_zoom: 14, //was 15
      stylePath: "/wp-content/themes/visitphilly/lib/google-map-style.json",
      icons: {
        active: "/wp-content/themes/visitphilly/dist/images/google-pin--active.svg",
        inactive: "/wp-content/themes/visitphilly/dist/images/google-pin--inactive.svg?1",
        hover: "/wp-content/themes/visitphilly/dist/images/google-pin--hover.svg",
        user: "/wp-content/themes/visitphilly/dist/images/dot-circle-solid.svg?1",
      },
      markers: [],
    },

    topMargin: {
      tablet: 20,
      desktop: 10,
    },

    // getting data from the global object since encode data in html attribute cause issues on titles with single or double qoute
    locations: VP_storyTracker_data,

    selectors: {
      wrapper: ".vp-story-tracker-module__wrapper",
      wrapperActive: ".vp-story-tracker-module__wrapper--active",
      storyItem: ".vp-story__item",
      module: ".vp-story-tracker-module",
      map: ".vp-story-tracker__map",
      docked: ".vp-story-tracker-module--docked",
      dockedToBottom: ".vp-story-tracker-module--docked-to-bottom",
      itemsWrapper: ".vp-story-tracker__items",
      item: ".vp-story-tracker__item",
      active: ".vp-story-tracker__item--active",
      open: ".vp-story-tracker-module--open",
      close: ".vp-story-tracker__close",
      expandmap: ".vp-story-tracker__expandmap",
      expandmapclose: ".vp-story-tracker__expandmapclose",
      showuserlocation: ".vp-story-tracker__showloc",
      article: ".vp-article-section",
      breaker: ".vp-article-breaker", // Breaker inside the article
      menuBreaker: ".vp-story-tracker__breaker", // Breaker inside the story tracker
      menuBreakerActive: ".vp-story-tracker__breaker--active", // Breaker inside the story tracker
      menuBreakerSelected: ".vp-story-tracker__breaker--selected", //
      hasActive: ".vp-story-tracker__items--has-active",
    },
    isIE11: (!!window.MSInputMethodContext && !!document.documentMode),
    selectorItemsScroll: true,
    selectorScrollReset: null,

    waypoints: [],
    waypointsBreaker: [],
    minSelectorItemHeight: 24, // default / can change after calculation in updateVariables function
    isInit: false,
    mapInit: false,
    mapClick: false,
    loadingHash: window.location.hash,
    hashInit: false,

    

    init: function() {

      if ($( VP.storyTracker.selectors.module ).length > 0 ) {
        // console.log("[storytracker] init (queued) : updating arrangement");
        var _this = VP.storyTracker;

        // Add a class to the body to fix the width of the article contents so it will not overlap the story tracker
        $( 'body' ).addClass('has-story-tracker');
        _this.module = $( _this.selectors.module );
        _this.updateModuleArrangement(); // this breaks the ads
        if (window.expandmapstart) {
          VP.storyTracker.delayedinit();
        }
        else {
          VP.documentEvents.onDelayInit( VP.storyTracker.delayedinit );
        }

        // Listen once for article filter updates
        window.addEventListener('vp:articles:filtered', (e) => {
            if (!e?.detail?.textIds) return;
            VP.storyTracker.applyFilter(new Set(e.detail.textIds));
        });

        _this.enabled = true;
      }
      else {
        // console.log("no [storytracker]");
      }
    },
    
    delayedinit: function() {
      // console.log("[storytracker] execute delayed init");

      var _this = VP.storyTracker;


      _this.map.element = $( _this.selectors.map );

      _this.initMap();
      _this.updateVariables();

      _this.checkScrollPosition();
      _this.waypointsInit();
      _this.popstate();
      _this.itemClicked = false;
      _this.activeItem = null;
      _this.lastWindowTop = 0;
      _this.isScrolling = false;
      _this.isUpdating = false;
      _this.isOpen = false;
      _this.isEngaged = false;
      _this.eventHandlers();
      _this.isInit = true;
      setTimeout(function() {
        // initialize height check after delay
        _this.heightCheck();
        _this.waypointsInit();

        // resfresh ads to ensure display after init
        //if (typeof(googletag.pubads) == "function") {
        //  console.log("[storytracker] REFRESH ADS AFTER DELAY : changeCorrelator false initial");
        //  googletag.pubads().refresh(null,{changeCorrelator: false});
        //}

      },2000);


    },
    heightCheck:function() {
      var _this = this;
      _this.resfreshtimer = setInterval(_this.heightTest,2000);
    },
    heightTest:function() {
      var _this = this;
      cheight = $(VP.storyTracker.selectors.wrapper).height();
      //console.log("[storytracker] heightTest(): " + cheight);
      if (cheight != _this.lastheight) {
        if (typeof(Waypoint) == "function") {
         // console.log("[storytracker] Waypoint.refreshAll()");
          Waypoint.refreshAll();
        }
      }
      _this.lastheight = cheight;

    },
    hashCheck: function() {
      var _this = this;
      // console.log("[storytracker] hashCheck storytracker: " +  _this.loadingHash );

      if (_this.loadingHash != "") {
        hashlink = _this.loadingHash;
        if (hashlink.indexOf("vp-article-section--item") != -1) {
          hashlinknum = hashlink.replace("#vp-article-section--item-","");
        }
        else {
          hashlink = hashlink.replace("#","");
          $section = $(".vp-article-section[data-textid='"+hashlink +"']");
          if (!$section.length) { // backwards compatible to use without dashes
             hashlink = hashlink.replace("-","")
             $section = $(".vp-article-section[data-textidalt='"+ hashlink +"']");
          }
          hashlinknum = $section.data("item-no");
          // console.log("alt HASH");
          // console.log($section);
          // console.log(hashlinknum);
        }
      //  $sectionitem = $(hashlink);
        //_this.scrollToItem(hashlinknum);

        $itemlink = $(".vp-story-tracker__item[data-item-no='"+hashlinknum+"']");
        if ($itemlink.length == 1) {
            _this.hashInit = true;

            if( VP.breakpoint.currentBreakpoint === 'small' ) {
              // if mobile, open menu first
              _this.open();
            }

            $itemlink.trigger("click");
            _this.viewItem($itemlink);

            setTimeout(function() {
              _this.hashInit = false;
              // console.log("disable hash init");
            },2000);

          // This module only have a closed state on mobile.
        }
        _this.loadingHash = "";
      }
    },

    updateVariables: function() {
      var _this = this;

      // Get the top position of the module
      if( VP.breakpoint.currentBreakpoint === 'small' ) {
        _this.top = _this.module.offset().top - VP.nav.wrapper.outerHeight() + $( _this.selectors.map ).outerHeight();
      } else if( VP.breakpoint.currentBreakpoint === 'medium' ) {
        _this.top = _this.module.offset().top - VP.nav.wrapper.outerHeight() - _this.topMargin.tablet;
      } else {
        _this.top = _this.module.offset().top - VP.nav.wrapper.outerHeight() - _this.topMargin.desktop;
      }

      // Get the height of the shortest story tracker items
      // Used to calculate position when opening up item selector
      if( VP.breakpoint.currentBreakpoint === 'small' ) {
        var trackerItemListHeight = [];
        $( 'a', _this.selectors.item ).each(function ( index, ele ) {
          trackerItemListHeight.push(ele.offsetHeight);
        });
        _this.minSelectorItemHeight = Math.min.apply(null, trackerItemListHeight);
      }

    },
    applyFilter: function(visibleIdSet) {
    const _this = this;

    // 1) Sync right-hand list visibility
    const $items = $(_this.selectors.itemsWrapper).find(_this.selectors.item);
    $items.each(function () {
        const id = this.dataset.textid;
        const show = id && visibleIdSet.has(id);
        if (show) {
        this.classList.remove('is-hidden');
        this.style.display = '';
        } else {
        this.classList.add('is-hidden');
        this.style.display = 'none';
        }
    });

    // 2) Hide/show menu breakers based on following visible items
    _this.updateMenuBreakers();

    // 3) Toggle markers + fit bounds
    _this.ensureMarkerIndex();           // one-time index of markers by textId
    _this.updateMarkersVisible(visibleIdSet);
    _this.fitMapToVisible();

    // (Optional) if an active item is now hidden, clear its “active” state
    const $active = $(_this.selectors.itemsWrapper).find(_this.selectors.active);
    if ($active.length && $active[0].classList.contains('is-hidden')) {
        $active.removeClass(_this.selectors.active.replace('.', ''));
    }
    },

    updateMenuBreakers: function () {
    const _this = this;
    const breakers = $(_this.selectors.itemsWrapper).find(_this.selectors.menuBreaker);

    breakers.each(function () {
        let sib = this.nextElementSibling;
        let hasVisible = false;

        // look ahead until the next breaker (or end) for any visible item
        while (sib) {
        if (sib.matches(_this.selectors.menuBreaker)) break;
        if (sib.matches(_this.selectors.item) && !sib.classList.contains('is-hidden')) {
            hasVisible = true;
            break;
        }
        sib = sib.nextElementSibling;
        }

        this.classList.toggle('is-hidden', !hasVisible);
        this.style.display = hasVisible ? '' : 'none';
    });
    },

    // Build a marker index (textId -> marker). We do it lazily the first time.
    ensureMarkerIndex: function () {
    const _this = this;
    if (_this._markerIndexBuilt) return;
    if (!_this.map || !_this.map.obj || !_this.map.markers || !_this.map.markers.length) return;

    // Map story-tracker list items by rounded lat,lng → textId
    const round = (n) => Math.round(Number(n) * 1e6) / 1e6;
    const coordToId = new Map();
    $(_this.selectors.itemsWrapper).find(_this.selectors.item).each(function () {
        const lat = this.dataset.lat, lng = this.dataset.lng, id = this.dataset.textid;
        if (!lat || !lng || !id) return;
        coordToId.set(`${round(lat)},${round(lng)}`, id);
    });

    // Attach __textid onto each marker by position
    _this.map.markers.forEach((m) => {
        try {
        const pos = m.getPosition && m.getPosition();
        const key = pos ? `${round(pos.lat())},${round(pos.lng())}` : null;
        const id = key ? coordToId.get(key) : null;
        if (id) m.__textid = id;
        } catch (_) {}
    });

    _this._markerIndexBuilt = true;
    },

    updateMarkersVisible: function (visibleIdSet) {
    const _this = this;
    if (!_this.map || !_this.map.markers) return;

    _this.map.markers.forEach((m) => {
        // If we never matched an id, leave it alone (treat as visible).
        if (!('__textid' in m)) return;
        const show = visibleIdSet.has(m.__textid);
        if (typeof m.setVisible === 'function') {
        m.setVisible(show);
        } else if (typeof m.setMap === 'function') {
        m.setMap(show ? _this.map.obj : null);
        }
    });
    },

    fitMapToVisible: function () {
    const _this = this;
    if (!_this.map || !_this.map.obj || !_this.map.markers) return;

    // Collect visible markers
    const visibleMarkers = _this.map.markers.filter((m) => {
        if ('getVisible' in m && typeof m.getVisible === 'function') return m.getVisible();
        // fallback heuristic
        try { return !!m.getMap(); } catch (_) { return true; }
    });

    if (!visibleMarkers.length) return; // keep current view

    const bounds = new google.maps.LatLngBounds();
    visibleMarkers.forEach((m) => {
        try { bounds.extend(m.getPosition()); } catch (_) {}
    });

    if (!bounds.isEmpty()) {
        _this.map.obj.fitBounds(bounds);
        // Optional: clamp zoom if you don’t want to over-zoom on one point
        // google.maps.event.addListenerOnce(_this.map.obj, 'bounds_changed', function () {
        //   const z = _this.map.obj.getZoom();
        //   if (z > 16) _this.map.obj.setZoom(16);
        // });
    }
    },

    eventHandlers: function() {
      var _this = this;
      var isScrolling;

      VP.helpers.detectMobile();

      $( window ).on("scroll",function( e ) {
        _this.checkScrollPosition();
        _this.isScrolling = true;
        // Clear our timeout throughout the scroll
        window.clearTimeout( isScrolling );

        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function() {

          // Run the callback
          _this.isScrolling = false;

        }, 66);
      });

      $( window ).on('load',function() {
        _this.update();
      });

      $( window ).on('resize',function() {

        // User is scrolling and possibly just using a mobile or tablet and the browser toolbar just appeared
        if( _this.isScrolling ) {
          return;
        }
        
        
        _this.update();
      });

      // Story tracker item click event
      $( _this.selectors.module ).on('click', _this.selectors.item + ', ' + _this.selectors.menuBreaker , function(e) {
        e.preventDefault();
        var $obj = $(this);

        if (_this.isIE11) {
          _this.selectorItemsScroll = false;

          // Reset timeout to have story tracker menu scroll if user clicks on another element quickly
          if (_this.selectorScrollReset) {
            window.clearTimeout(_this.selectorScrollReset);
          }

          _this.selectorScrollReset = setTimeout(function() {
            _this.selectorItemsScroll = true;
          }, 2000);
        }

        if( _this.isOpen || VP.breakpoint.currentBreakpoint !== 'small' ) {
          var itemNo = $( this ).data( "item-no" );

          if( $obj.hasClass( _this.selectors.item.replace( '.', '' ) ) ) {
            // Add to browser history with the url #vp-article-section--item-{itemNo}
            hashlink = "#vp-article-section--item-" + itemNo;
            if (true) { // always do this // was VP.brewSort.enabled &&
              hashlink = "#" + $( this ).data( "textid" );
            }
            //console.log("REPLACE 1: " + hashlink);
            try {
              history.replaceState( {item: itemNo}, _this.locations[itemNo - 1].name,  hashlink);
            }
            catch (error) {
              // console.log("unable to replace state: "+ error);
            }

            _this.scrollToItem( itemNo );
          } else {
            // if the clicked item is a breaker
            hashlink = "#" + VP.helpers.slugify($obj.text());
            // console.log("REPLACE 2: " + hashlink);
            try {
              history.replaceState( {item: ''}, $obj.text(), hashlink);
            }
            catch (error) {
              // console.log("unable to replace state: "+ error);
            }
            _this.scrollToItem( $obj.index('.vp-story-tracker__breaker'), true );
          }

          if( VP.breakpoint.currentBreakpoint !== 'small'  && !_this.expanded) {
            _this.open();
          } else if( _this.isOpen ) {
            _this.close(); // clears active item
          }
        } else {
          _this.open();
        }
      });

      // Since mobile browsers require two taps to actually fire a 'click' (first tap only fires 'hover'),
      // We have to force select an item within allowed tap duration (should not fire on long touch)
      if ( VP.helpers.isMobile() ) {
        $( _this.selectors.item ).each(function (i, selectorItem) {
          var _item = $( this );
          var tapSelectTimeout;
          var tapShouldSelect = false;

          // A Function that will trigger when the close button in the module is triggered (only visible in mobile viewport)
          $( _this.selectors.close ).on("click",function(e) {
            e.preventDefault();
            _this.close();
          });

          // MTU: the events below seem to be missing a jquery object, but fixing this creates scrolling issues
          // unclear if these events are working or if they are even necessary
          // 9/10/18 REMOVED BECAUSE ERROR DOES SEEM TO HALT ASPECTS OF EXECUTING JAVASCRIPT WITHIN SCRIPT
/*          selectorItem.on('touchstart', function(e) {
            e.preventDefault();
            tapShouldSelect = true;
            tapSelectTimeout = setTimeout(function () {
              tapShouldSelect = false;
            }, 100);
          });

          selectorItem.on('touchend', function(e) {
            e.preventDefault();
            if ( tapShouldSelect ) {
              _item.trigger( 'click' );
            }
            tapShouldSelect = false;
          });*/


        });
      }

      // A Function that will trigger when the closee button in the module is triggered (only visible in mobile viewport)
      $( _this.selectors.close ).on("click",function(e) {
        // console.log("[TRIGGER CLOSE]");
        e.preventDefault();
        _this.close();
      });

      //$( _this.selectors.item ).hover(function(){
      $( _this.selectors.itemsWrapper ).on("mouseenter",_this.selectors.item, function() {
        // Prevent triggering on mobile when the module is closed
        if( VP.breakpoint.currentBreakpoint === 'small' && !_this.module.hasClass( _this.selectors.open.replace( '.', '' ) ) ) {
          return;
        }

        var itemNo = $( this ).data( "item-no" ) - 1;

        _this.focusMapMarker( itemNo );
      });
      $( _this.selectors.itemsWrapper ).on("mouseleave",_this.selectors.item, function() {
        // Prevent triggering on mobile when the module is closed
        if( VP.breakpoint.currentBreakpoint === 'small' && !_this.module.hasClass( _this.selectors.open.replace( '.', '' ) ) ) {
          return;
        }

        if( _this.activeItem !== null ) {
          _this.focusMapMarker( _this.activeItem );
        } else {
          _this.refreshMap();
        }
      });
    },
    rebuildMap: function() {
      var _this = this;
      if (_this.mapInit) {
        _this.removeMarkers();
        _this.addMarkers();
        _this.update();
      }
    },
    update: function() {
      var _this = this;
      _this.isUpdating = true;
      _this.refreshMap();
      _this.undock(true);      
      _this.updateVariables();      
      _this.dock();      
      _this.checkScrollPosition();
      _this.waypointsInit();
      _this.isUpdating = false;
      _this.hashCheck();
      _this.updateExpanded();
    },

    initMap: function() {
      var _this = this;

      /*
       * Get map styling from /wp-content/themes/visitphilly/lib/google-map-style.json
       * JSON generated from https://mapstyle.withgoogle.com/
       */
      var jqxhr = $.getJSON( _this.map.stylePath )
        .done(function() {
          _this.map.style = jqxhr.responseJSON;

          if ( typeof google === 'object' && typeof google.maps === 'object' ) {
            _this.generateMap();
          } else {
            VP.helpers.loadScript( "https://maps.googleapis.com/maps/api/js?key=" + _this.map.element.data( 'api-key' ) + "&callback=VP.storyTracker.generateMap");
          }
        })
        .fail(function() {
          console.error( "Cannot load map style" );
        });

      
    },
   
    generateMap: function() {
      var _this = this;
      
      // Generate map
      _this.map.obj = new google.maps.Map( document.getElementById( _this.selectors.map.replace( '.', '' ) ), {
        draggable: true,
        zoomControl: true,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        maxZoom: 15,
       
      });

      // , gestureHandling: "cooperative"
     
   

      _this.infowindow = new google.maps.InfoWindow({
        content: "",
        maxWidth: 200,
      });
      // Apply map styling
     styledMapType = new google.maps.StyledMapType( _this.map.style, { name: 'Styled Map' } );
      _this.map.obj.mapTypes.set( 'styled_map', styledMapType );
      _this.map.obj.setMapTypeId( 'styled_map' );

      _this.map.bounds = new google.maps.LatLngBounds();

      _this.addMarkers();

      _this.expandformobile = VP.helpers.isMobileSize();
      $( _this.selectors.expandmap ).on("click", function(e) {
        // console.log("expand map");
        e.preventDefault();
        _this.mapexpand();
        
      })

      $( _this.selectors.expandmapclose ).on("click",function(e) {
        e.preventDefault();
        _this.mapexpand(true);
      });
    
      $( _this.selectors.showuserlocation ).on("click",function(e) {
        e.preventDefault();
        _this.mapuserlocation();
      });
      if (window.expandmapstart) {
        _this.mapexpand();
      }

      _this.mapInit = true;
    },
    mapexpand: function (_closeexpand) {
      var _this = this;
      // console.log("[mapexpand]");
      //$(VP.storyTracker.selectors.wrapper).css("")
      var $tracker = $(".vp-story-tracker-module");
    //  var $sortholder = $(".vp-sortholder");
      if (!_closeexpand) { // EXPAND MAP
 
        $(".vp-story-tracker__items").hide();             
        $tracker.prependTo($("body")).addClass("fullmap");    
         
        $("body").addClass("expandedmap");
        if (_this.expandformobile) {
          $("body").addClass("expandformobile");
        }
       
        $("html").addClass("viewasmobile");
              
        if (!$(".expandedcontentwrap").length) {
          $(".vp-cinematic-hero__spacer,.vp-cinematic-hero,.vp-disclaimer-wrap").wrapAll("<div class='contentheaderwrap'></div>");
          $(".vp-module-intro-location").append("<div class='mapintroclose'>Close to Explore Map<i class='vp-icon-close'><span class='screen-reader-text'>Close</span></i></div>");
  
          $(".wrap.container,.vp-footer").wrapAll("<div class='expandedcontentwrap'><div class='expandedcontent'></div></div>");

          var _heading = $(".vp-cinematic-hero__heading").html();
          $tracker.prepend("<div class='mapheading'><div class='mapheadingwrap'>"+_heading+"</div></div>");



          $(".expandedcontent").prepend("<div class='mobileviewclosewrap'><div class='mobileviewclose'><i class='vp-icon-close'><span class='screen-reader-text'>Close</span></i></div>");

         

          $(".mobileviewclose, .mapintroclose").on("click", function() {
            VP.storyTracker.mapmobileclose();
          });
          $(".mapheadingwrap").on("click").on("click", function() {
            VP.storyTracker.mapmobileshow(0);
          });
        }
        // move sort holder // doesn't really make sense for mobile, can't sort
        //  if ($sortholder.length) {
        //   $(".expandedcontentwrap").before($sortholder);
        // }
        VP.nav.dock(true);
        VP.storyTracker.expanded = true;        
        _this.forcebookingmobile();

       // if (!_this.isEngaged  && !_this.expandmapstart) {
        //  console.log("[FIT BOUNDS ON EXPAND]");
          _this.map.obj.fitBounds( _this.map.bounds );
       // }

        
      }
      else { // CLOSE MAP
        $(".vp-story-tracker__items").show();        
        $tracker.prependTo($(".vp-modules")).removeClass("fullmap");    
        $("body").removeClass("expandedmap");        

        $("html").removeClass("viewasmobile");
        $("body").removeClass("expandformobile");

        // move sort holder
        // if ($sortholder.length) {
        //   $(".vp-sectioncontainer").before($sortholder);
        // }

        VP.nav.isForcedDock = false;
        VP.nav.dock();
        VP.storyTracker.undock();
        VP.storyTracker.expanded = false;
        _this.forcebookingmobile(true);
        $(".expandedcontentwrap").show(); /////////// WHEN HIDEING FROM MOBILE
      }

      _this.updateExpanded();
      VP.breakpoint.manual(); // set breakpoint small
      
      setTimeout(function() {
        Waypoint.refreshAll();
        VP.reveal.updatePosition();
        _this.updateExpanded();
        VP.cinematicHero.onResize();

        // REFRESH ADS ON CHANGE
        if (!VP.helpers.isMobileSize()) {
          // console.log("[EXPAND MAP CHANGE] REFRESH ADS");
          VP.helpers.forceAdRefresh($(".expandedcontentwrap"))
        }
        // only refresh ads on close expand
        if (VP.helpers.isMobileSize() && _closeexpand) {
          // console.log("[EXPAND MAP CHANGE] MOBILE REFRESH ADS");
          VP.helpers.forceAdRefresh($(".expandedcontentwrap"))
        }
        
        
     

        if (!window.expandmapstart) {
          // console.log("[mapexpand] Scroll to item 1");
          VP.storyTracker.scrollToItem( 1 );
          VP.storyTracker.focusMapMarker( 0 );
        }
        else {  // for mobile show intro on load
          if (_this.expandformobile) {
            VP.storyTracker.mapmobileshow(0);
          }
        }
        window.expandmapstart = false; // only on load
        $("body").addClass("expandready");
      },500);

    },
    updateExpanded: function() {
      var _this = this;
      _this.expandformobile = VP.helpers.isMobileSize();
      if (_this.expandformobile && _this.expanded) {
        $("body").addClass("expandformobile");
      }
      else {
        $("body").removeClass("expandformobile");
      }

      var $map = $(".vp-story-tracker__map");
      var $mapmodule = $(".vp-story-tracker-module");
      var $contentwrap = $(".expandedcontentwrap");
      if (_this.expanded)  {
        var  _sidewidth = 380;

        if (_this.expandformobile) {
          _sidewidth = 0;
        }

        
        
        var _top = $("header").height();
        if (!_this.expandformobile && $(".vp-sortbuttons.fixed.top").length  == 1) {
          _top += $(".vp-sortbuttons.fixed.top").height();
        }
        if (VP.brewSort.enabled) {
          VP.brewSort.checkScrollPosition();
        }
        var _w = $( window ).width() - _sidewidth;
        var _h = $( window ).height() - _top;
        $mapmodule.height(_h).width(_w).css("top",_top + "px").css("right",_sidewidth + "px").css("margin-top","0");
        // console.log("UPDATE EXPANDED",_top);
        
        $map.height(_h).width(_w);
        $contentwrap.width(_sidewidth).css("margin-left",_w);
        if (!_this.expandformobile) {
          $contentwrap.css("padding-top",_top + "px");
        }
        if (_this.expandformobile) {
          $mapmodule.css("right","");
          $contentwrap.css("width","").css("margin-left","").css("padding-top","");
        }
       // $(".expandedcontentwrap").height(_h).css("top",_top + "px").width(_sidewidth);
      }
      else {
        $mapmodule.width("").height("").css("top", "").css("right","").css("margin-top","");
        $map.width("").height("");
        $contentwrap.css("width","").css("margin-left","");
        $contentwrap.css("padding-top","");
      }
    },
    // replace inpage css coming from JRS javascript to force mobile view, will need to change if CSS changes from 3rd party
    forcebookingmobile: function (_revert) {      
      var _this = this;
      if (_this.expandformobile) {
        return;
      }

      if (!_revert) {
        $("style").each(function() { 
          var _text = $(this).text(); 
        
          if (_text.indexOf("jrs-widget-1332") != -1  && _text.indexOf("@media (min-width:1000px) and (max-width:1400px){") != -1) 
            {             
              $(this).data("data-bookingcode",_text);

              _text = _text.replace("@media (min-width:1000px) and (max-width:1400px)", "@media (min-width:9999999px)");
              _text = _text.replace("max-width:999px", "max-width:9999999px");
              _text = _text.replace("max-width:698px", "max-width:1000000px");
              
              $(this).text(_text);
              $(this).attr("data-bookingcss", "fixed");
              
              
            } 
          });
        }
        else {
          $widget = $("style[data-bookingcss]");
          $widget.text( $widget.data("data-bookingcode"));
        }
    },
    mapmobileshow: function(_index) {
      var _this = this;
      $(".expandedcontentwrap").addClass("active");         
      $(".contentheaderwrap, .vp-module-intro-location, .expandedcontentwrap .vp-story__item").addClass("mapmobilehide").removeClass("mapmobileshow");
      $(".expandedcontentwrap").scrollTop(0);
      if (_index == 0) {
        // show intro content
        if (_this.delayonce) {
          $(".expandedcontentwrap").addClass("delayed"); 
          _this.delayonce = false;
        }
        $(".contentheaderwrap, .vp-module-intro-location").removeClass("mapmobilehide").addClass("mapmobileshow");  
      }
      else {
        $(".expandedcontentwrap").removeClass("delayed"); 
        $(".expandedcontentwrap .vp-story__item[data-value='"+_index+"']").removeClass("mapmobilehide").addClass("mapmobileshow");
      }
     
    },
    mapmobileclose: function() {
      var _this = this;
      $(".expandedcontentwrap").removeClass("active").removeClass("delayed");
      _this.lastclicked = null;
    },
    infowindowshow: function(marker) {
      var _this = this;
      clearTimeout(_this.infotimer);
      _this.infowindow.setContent("<a href='javascript:;' onclick='VP.storyTracker.clickinfowindow("+marker.markerindex+");'>"+marker.markertitle+"</a>");
      _this.infowindow.open(_this.map,marker);
    },
    infowindowclose: function() {
      var _this = this;
      clearTimeout(_this.infotimer);
      _this.infotimer = setTimeout(function() {
        _this.infowindowclosenow();
      },_this.infowindowclosetimeout);
      
    },
    infowindowclosenow: function() {
      var _this = this;
      _this.infowindow.close();
    },
    clickinfowindow: function(_which) {
      var _this = this;
      var _itemnum = _which + 1;
      if (_this.expandformobile) {
        _this.mapmobileshow(_itemnum);
      }
      else {
        //_this.scrollToItem(_itemnum);
        $(".vp-story-tracker__item[data-item-no="+_itemnum+"]").trigger("click");
      }
    },
    mapuserlocation: function () {
      var _this = this;
      // console.log("[mapuserlocation]");

      if (VP.storyTracker.hasuserlocation) {
        VP.storyTracker.locationSuccess(VP.storyTracker.userpos);
      }
      else {
        VP.helpers.location(VP.storyTracker.locationSuccess,VP.storyTracker.locationFailure);
        // FOR TESTING // VP.storyTracker.locationFailure("fail");
      }
    },
    locationSuccess: function(position) {
      var _this = VP.storyTracker;
      _this.userpos = position;
      _this.userlat =  position.coords.latitude;
      _this.userlng =  position.coords.longitude;
      // console.log("Found Location at: " + _this.userlat + "," + _this.userlng);
      _this.hasuserlocation = true;      
      //_this.brewsort("near");
      VP.storyTracker.addUserLocation(_this.userlat,_this.userlng);
    },
    locationFailure: function(error_message) {
      var _this = VP.storyTracker;
      console.error('An error has occured while retrieving location', error_message);
      alert("VisitPhilly.com was unable to access your location. Philadelphia City Hall will be used as the default location.");
      _this.userlat =  "39.952583";
      _this.userlng = "-75.165222";
      _this.hasuserlocation = true;
      _this.locationName = "Philadelphia City Hall";
      //_this.brewsort("near");
      _this.userpos = {}
      _this.userpos.coords = {
        "latitude":_this.userlat,
        "longitude":_this.userlng,
      };
      VP.storyTracker.addUserLocation(_this.userlat,_this.userlng);
    },
    addUserLocation: function(ulat,ulng) {
      // console.log("[addUserLocation] ",ulat, ulng);
      var _this = this;
      if (!_this.userlocset) {
        var pos = new google.maps.LatLng( ulat,ulng);

        var icon = {
          url: _this.map.icons.user, // url
          scaledSize: new google.maps.Size(25, 25), // size
        };
        var marker = new google.maps.Marker({
          map: _this.map.obj,
          position: pos,
          icon: icon,
          clickable: true,
          markertitle: "Your Location"
        });
        marker.addListener('click', function() {
          _this.infowindowshow(marker);
        });
        _this.userlocset = true;
        _this.usermarker = marker;
      }
      //_this.usermarker.trigger("click");
      new google.maps.event.trigger(_this.usermarker, 'click' );
    },
    addMarkers: function() {
      var _this = this;
      //var clickablemarkers = !VP.helpers.isMobile();

      // testing mobile clickable markers
      var clickablemarkers = true;
      // Fetch each locations then add marker on the map
      $.each(_this.locations, function( i, location ) {
        if (location.lat && location.lng && !isNaN(location.lat) && !isNaN(location.lng)) {

          var pos = new google.maps.LatLng( location.lat, location.lng );
          var marker = new google.maps.Marker({
            map: _this.map.obj,
            position: pos,
            icon: _this.map.icons.inactive,
            clickable: clickablemarkers,
            markertitle: location.text + _this.bubblelinktext,
            markerindex: i,
          });

          if (clickablemarkers) {

            marker.addListener('click', function() {
              var _index = i;
              var clickitem = i+1

              var $menuItem = $( _this.selectors.itemsWrapper ).children( _this.selectors.item ).eq( _index )[0];
              _this.viewItem( $menuItem );

              if (!_this.isOpen) {
                _this.open(0);
              }

              _this.activeItem = i;
              // console.log("[SET ACTIVE]",_this.activeItem );
              _this.mapClick = true;
              $(".vp-story-tracker__item[data-item-no="+clickitem+"]").trigger("click");
              this.set( 'mouseclicked', true );
              _this.infowindowshow(marker);
              _this.mapClick = false;
              /// TODO? CHECK FOR DOUBLE CLICK FOR MOBILE VIEW

              if (_this.expanded && _this.expandformobile && _this.lastclicked == clickitem) {
                VP.storyTracker.mapmobileshow(clickitem);
              }              
              this.setIcon(_this.map.icons.active);
              _this.lastclicked = clickitem;
              VP.helpers.firecustomGTMEvent("clickstorytrackermapitem");
            });

            marker.addListener('mouseover', function(e) {
              if (!_this.isEngaged) { return; }
       
              if (_this.activeItem != i && !this.mouseclicked) {
                this.setIcon(_this.map.icons.hover);
              }
              _this.infowindowshow(marker);
            });

            marker.addListener('mouseout', function(e) {
              if (!_this.isEngaged) { return; }
              // console.log(_this.activeItem );
              if (_this.activeItem != i && !this.mouseclicked) {               
                this.setIcon(_this.map.icons.inactive);
              }
              this.set( 'mouseclicked', false );
              _this.infowindowclose();
            });
          }

          // Add ID so we can call it by ID later if we need to
          marker.set( 'id', i );
          _this.map.markers[i] = marker;

          // Extend map bounds
          _this.map.bounds.extend( pos );


          /// ADD ADDTIONAL MARKERS
          $.each(location.addl, function( j, addloc ) {
            if (addloc.loclat && addloc.loclng && !isNaN(addloc.loclat) && !isNaN(addloc.loclng)) {
              // console.log("[ADD ADDL]",addloc.loclat, addloc.loclng);
              var addpos = new google.maps.LatLng( addloc.loclat, addloc.loclng );
              var addmarker = new google.maps.Marker({
                map: _this.map.obj,
                position: addpos,
                icon: _this.map.icons.inactive,
                clickable: clickablemarkers,
                //title: location.text + "<br>" + addloc.locname + _this.bubblelinktext,
                markertitle: addloc.locname + _this.bubblelinktext,
                markerindex: i,
              });
              addmarker.addListener('click', function() {
                //_this.infowindowshow(addmarker);
                var _index = i;
                var clickitem = i+1

               // var $menuItem = $( _this.selectors.itemsWrapper ).children( _this.selectors.item ).eq( _index )[0];
                //_this.viewItem( $menuItem );

                if (!_this.isOpen) {
                  _this.open(0);
                }

                _this.mapClick = true;
                $(".vp-story-tracker__item[data-item-no="+clickitem+"]").trigger("click"); // does the scroll to
                this.set( 'mouseclicked', true );
                _this.infowindowshow(addmarker);
                _this.mapClick = false;
                /// TODO? CHECK FOR DOUBLE CLICK FOR MOBILE VIEW

                if (_this.expanded && _this.expandformobile && _this.lastclicked == clickitem) {
                  VP.storyTracker.mapmobileshow(clickitem);
                }              
                this.setIcon(_this.map.icons.active);
                _this.lastclicked = clickitem;
              });
              addmarker.addListener('mouseover', function() {
                if (!_this.isEngaged) { return; }
               
                if (_this.activeItem != i && !this.mouseclicked) {
                  this.setIcon(_this.map.icons.hover);
                }
                _this.infowindowshow(addmarker);
              });
  
              addmarker.addListener('mouseout', function() {
                if (!_this.isEngaged) { return; }
                if (_this.activeItem == i) {
                  this.setIcon(_this.map.icons.active);
                }
                else {
                  this.setIcon(_this.map.icons.inactive);
                }
                this.set( 'mouseclicked', false );
                _this.infowindowclose();
              });
              _this.map.bounds.extend( addpos );
              // console.log(addmarker);
            }
          });



        }
        else {
          // console.log("ERROR: invalid lat and/or lng for location");
          // console.log(location);
        }
      });

      // Make the bounds/locations the center of the map
      _this.map.obj.fitBounds( _this.map.bounds );
    },
    removeMarkers: function() {
      var _this = this;
        $.each(_this.map.markers, function(index, marker) {
          if (marker) {
            marker.setMap(null);
          }
        });
    },

    // Check if we need to dock/undock the module.
    checkScrollPosition: function() {
      var _this = this;
      var _windowTop = $( window ).scrollTop();
      var _dockTriggerPosition = _windowTop + $(window).height();
      var _wrapperBottom = $( _this.selectors.wrapper ).offset().top + $( _this.selectors.wrapper ).outerHeight();
      var _moduleMarginTop = 0;
      var _moduleTop = null;
      var _moduleBottom = null;
      var _bottomMargin = 0;

      if( _windowTop > _this.lastWindowTop ) {
        _this.isScrollingDown = true;
        _this.isScrollingUp = false;
      } else {
        _this.isScrollingDown = false;
        _this.isScrollingUp = true;
      }

      _this.lastWindowTop = _windowTop;

      if( VP.breakpoint.currentBreakpoint === "small" ) {
        _moduleTop = $(_this.selectors.itemsWrapper).offset().top;
        _moduleBottom = _moduleTop + $(_this.selectors.itemsWrapper).outerHeight();
        _dockTriggerPosition = _windowTop + VP.nav.wrapper.outerHeight() + $( _this.selectors.itemsWrapper ).outerHeight();
      } else {
        _bottomMargin = 50;
        _moduleTop = _this.module.offset().top;
        _moduleBottom = _moduleTop + _this.module.outerHeight();
      }

      if( VP.breakpoint.currentBreakpoint === "medium" ) {
        _moduleMarginTop = _this.topMargin.tablet;
      } else if( VP.breakpoint.currentBreakpoint !== "small" ) {
        _moduleMarginTop = _this.topMargin.desktop;
      }

      dockpoint = _wrapperBottom - _bottomMargin; // original setting
      dockpoint = dockpoint + $(window).height()/2;

      if (VP.storyTracker.expanded) {
        return;
      }

      //VP.helpers.addIndicator(_dockTriggerPosition,"dockTriggerPosition","dockTriggerPosition");
      //VP.helpers.addIndicator((_wrapperBottom - _bottomMargin),"wrapperBottom-_bottomMargin","wrapminusbot");
      //VP.helpers.addIndicator((_wrapperBottom),"wrapperBottom","wrapperBottom");
      //VP.helpers.addIndicator((dockpoint),"dockpoint","dockpoint");

      _wrapperBottom - _bottomMargin

      // Reached the top of the story wrapper while scrolling down
      if( !_this.module.hasClass( _this.selectors.docked.replace( '.', '' ) ) && _windowTop >= _this.top && _moduleBottom < _wrapperBottom && _this.isScrollingDown ) {
        //console.log("1 dock");
        _this.dock();

      // Reached the top of the story wrapper while scrolling up
      } else if( _this.module.hasClass( _this.selectors.docked.replace( '.', '' ) ) && _windowTop < _this.top && _this.isScrollingUp && !_this.module.hasClass( _this.selectors.dockedToBottom.replace( '.', '' ) ) ) {
        //console.log("2 undock");
        _this.undock();

      // Reached the bottom of the story wrapper while scrolling down
      } else if( !_this.module.hasClass( _this.selectors.dockedToBottom.replace( '.', '' ) ) && ( _dockTriggerPosition > dockpoint ) && _this.isScrollingDown ) {
        //console.log("3 dock bottom");
        _this.dockToBottom();

      // Reached the bottom of the story wrapper while scrolling up
    } else if( _this.module.hasClass( _this.selectors.dockedToBottom.replace( '.', '' ) ) && ( _dockTriggerPosition < dockpoint ) && _this.isScrollingUp ) {
      //} else if( _this.module.hasClass( _this.selectors.dockedToBottom.replace( '.', '' ) ) && _windowTop <= ( _moduleTop - _moduleMarginTop - VP.nav.wrapper.outerHeight() ) && _this.isScrollingUp ) {
        //console.log("4 dock");
        _this.dock();
      }


    },

    // A function that will dock the module
    dock: function() {
      var _this = this;
      _this.module.removeClass( _this.selectors.dockedToBottom.replace( '.', '' ) );
      _this.module.addClass( _this.selectors.docked.replace( '.', '' ) );
    },

    // A function that will stick the module to the bottom of the module wrapper
    dockToBottom: function() {
      var _this = this;
      _this.module.addClass( _this.selectors.dockedToBottom.replace( '.', '' ) );
    },


    // A function that will undock the module
    undock: function(retainActive) {
      var _this = this;
      retainActive = retainActive || false;
      _this.module.removeClass( _this.selectors.dockedToBottom.replace( '.', '' ) );
      _this.module.removeClass( _this.selectors.docked.replace( '.', '' ) );
      _this.refreshMap();
      _this.close();

      if( !retainActive ) {
        $( _this.selectors.item ).removeClass( _this.selectors.active.replace( '.', '' ) );
      }

      if( $( _this.selectors.active ).length === 0 ) {
        $( _this.selectors.itemsWrapper ).removeClass( _this.selectors.hasActive.replace( '.', '' ) );
      }

      var windowLocationPath = window.location.pathname;

      // This removes undefined that IE11 adds to the pathname which causes page to not reload.
      if (_this.isIE11) {
        windowLocationPath = windowLocationPath.replace(/undefined/i,'');
      }
      try {
        history.replaceState("", document.title, windowLocationPath + VP.helpers.utmParam);
      }
      catch (error) {
        // console.log("unable to replace state: "+ error);
      }
    },

    // A function that will open the module
    open: function( _delayTime ) {
      var _this = this;
      _this.module.addClass( _this.selectors.open.replace( '.', '' ) );
      var selectedItem = $('.vp-story-tracker__item--active');
      var selectedItemIndex = selectedItem.data('item-no') - 1;
      _this.focusMapMarker( selectedItemIndex );
      if (!_delayTime) {
        _delayTime = 200;
      }
      _this.isOpen = true;

      //console.log("open: " + selectedItemIndex);

      // Focus item
      if( VP.breakpoint.currentBreakpoint === 'small' ) {
        var minItemLineHeight = _this.minSelectorItemHeight;
        var selectedItemHeight = selectedItem.height();
        var selectedItemOffset = ( selectedItemHeight - minItemLineHeight ) / 2;

        if (_this.activeElement) {
          var _itemPos = _this.activeElement.position().top - $( _this.selectors.map ).outerHeight();
          // create an offset based on the index of the active item so all items can scroll into view
          var _scrollToPos = _itemPos + ( (  minItemLineHeight * ( selectedItemIndex - 1 ) ) - selectedItemOffset );

          // increase scrollTop delay for items further down the list
          // to allow mobile devices to scroll to correct position
          if (selectedItemIndex > 5) {
            _delayTime = 400;
          }

          setTimeout(function() {
            $( _this.selectors.itemsWrapper ).scrollTop(_scrollToPos);
          }, _delayTime);
        }
      }
    },

    // A function that will close the module
    close: function() {
      if( !this.isScrolling && !this.isUpdating ) {
        var _this = this;
        _this.isOpen = false;
       // _this.activeItem = null;
        //console.log("[clear active item]");
        _this.module.removeClass( _this.selectors.open.replace( '.', '' ) );

        $.each(_this.map.markers, function(index, marker) {
          if (marker) {
            marker.setIcon( _this.map.icons.inactive );
          }
        });
      }
    },

    // Update the center of the map. This is triggered when the viewport is being resized
    refreshMap: function() {
      var _this = this;
      if (!_this.mapInit) {
        return;
      }
      if ( typeof google === 'object' && typeof google.maps === 'object' ) {
        google.maps.event.trigger(_this.map.obj, 'resize');
        _this.map.obj.fitBounds( _this.map.bounds );
      }
    },

    // View article item
    viewItem: function( el ) {
      var _this = this;
      var selectedItemIndex = $( el ).data('item-no') - 1;
      var _itemPos = 0;
      _this.activeItem = selectedItemIndex;
      _this.activeElement = $( el );
      //console.log("[viewItem]" + selectedItemIndex);

      $( _this.selectors.wrapper ).addClass( _this.selectors.wrapperActive.replace( '.', '' ) );
      $( _this.selectors.item ).removeClass( _this.selectors.active.replace( '.', '' ) );
      $( _this.selectors.menuBreaker ).removeClass( _this.selectors.menuBreakerActive.replace( '.', '' ) );
      $( el ).addClass( _this.selectors.active.replace( '.', '' ) );
      $( _this.selectors.itemsWrapper ).addClass( _this.selectors.hasActive.replace( '.', '' ) );

      _this.findBreaker();

      // Update markers state (Will change the icon. Red if active, Grey when inactive)
      _this.focusMapMarker( selectedItemIndex );

      // Open the module. This module only have a closed state on mobile.
   
      if( VP.breakpoint.currentBreakpoint !== 'small' && !_this.expanded) {
        _this.open();
      } else if( !_this.isOpen ) {
        _this.close();
      }
      

      // get last position
      _this.focusMenuItem( $( el ) );
    },

    findBreaker: function() {
      var _this = this;
      var $breakerFinder = _this.activeElement.prevUntil( _this.selectors.menuBreaker ).prev();
      var $prevBreaker = false;
      var offset = $(window).outerHeight() / 2;

      // Check if element has a breaker
      if( $breakerFinder.length === 1 ) {
        $prevBreaker = $breakerFinder;
      } else if( $breakerFinder.length > 1 ) {
        $prevBreaker = $breakerFinder.last();
      } else if( _this.activeElement.prev() && _this.activeElement.prev().hasClass( _this.selectors.menuBreaker.replace( '.', '' ) ) ) {
        $prevBreaker = _this.activeElement.prev();
      }

      if( $prevBreaker.length && $prevBreaker.hasClass( _this.selectors.menuBreaker.replace( '.', '' ) ) ) {
        $prevBreaker.addClass( _this.selectors.menuBreakerActive.replace( '.', '' ) );
      }
    },

    // Handles the event when the article items are in-view
    waypointsInit: function() {
      var _this = this;
      var locationsCtr = 0;
      var breakerCtr = 0;
      var waypointSelector = null;
      var $items = $(_this.selectors.storyItem + ':not('+_this.selectors.module+')');
      // console.log("[storytracker] waypointsInit()");

      $.each($items, function( index ) {
        var $item = $(this);
        var offset = $(window).outerHeight() / 2;

        if( $item.data('type') === 'article-section' ) {
          waypointSelector = $item.children().first().attr('id');
        } else if( $item.data('type') === 'breaker' ) {
          waypointSelector = $( _this.selectors.breaker, $item ).attr('id');
        }

        // Destroy if waypoints already exist
        if( _this.waypoints[index] ) {
          _this.waypoints[index].destroy();
        }

        _this.waypoints[index] = new Waypoint({
          element: document.getElementById( waypointSelector ),
          offset: VP.nav.wrapper.outerHeight() + offset,
          handler: function( direction ) {

            if (_this.hashInit && !_this.itemClicked) {
              // console.log("[waypoints] hash init return");
              return;
            }

            if ($(".lazy-instagram:not('.loaded')").length && !_this.itemClicked) {
              // console.log("[waypoints] ig loading return");
              return;
            }
            if ($(".lazy-tiktok:not('.loaded')").length && !_this.itemClicked) {
              // console.log("[waypoints] ig loading return");
              return;
            }
            var _index = index;
            _this.scrollDirection = direction;
            var $b = $item;

            // User is scrolling up. Update variables to show the previous data.
            if( direction === 'up' ) {
              $item = $item.prev();
              _index--;
            }

            //console.log("way point handler: "+_index);
            hashlink = $item.data('url');

            //if (VP.brewSort.enabled && $item.find('[data-textid]').length == 1) {
            if ($item.find('[data-textid]').length == 1) {
              val = $item.find('[data-textid]').data('textid');
              if (val != "" && val != "undefined") {
                hashlink = "#"+val;
                //console.log(hashlink);
              } else {
                val = ""
              }
            }
            if (typeof(hashlink) == "string")
              hashlink = hashlink.replace("#vp-article-section--", "#");
            if( direction === 'up' && $item.index() !== 0 && !_this.itemClicked ) { // When the bottom of the current item is in-view
              //history.replaceState( {item: $item.data('value'), index: index}, $item.data('value'), $item.data('url') );
              //console.log("REPLACE 3: " + hashlink);
              VP.helpers.updateState($item.data('value'),_index,$item.data('value'),hashlink);
            }

            if( $item.data('type') === 'breaker' ) {
              // Remove active article item
              $( _this.selectors.item ).removeClass( _this.selectors.active.replace( '.', '' ) );

              // Make the in view breaker active
              $( _this.selectors.menuBreaker ).removeClass( _this.selectors.menuBreakerActive.replace('.', '') );
              $( _this.selectors.itemsWrapper ).children().eq(_index).addClass( _this.selectors.menuBreakerActive.replace('.', '') );
              $( _this.selectors.menuBreaker ).removeClass( _this.selectors.menuBreakerSelected.replace('.', '') );
              $( _this.selectors.itemsWrapper ).children().eq(_index).addClass( _this.selectors.menuBreakerSelected.replace( '.', '' ) );
              $( _this.selectors.itemsWrapper ).addClass( _this.selectors.hasActive.replace( '.', '' ) );

            } else {
              $( _this.selectors.menuBreaker ).removeClass( _this.selectors.menuBreakerSelected.replace('.', '') );
            }

            // Add item to browser history if it is in view. Also check if the item is triggered by the story tracker navigation.
            if( !_this.itemClicked && direction === 'down' && ( (typeof history.state === 'undefined' || !history.state) || (_index !== history.state.index && (!history.state.index || (history.state.index < _index && direction === 'down') || (history.state.index > _index && direction === 'up'))) ) ) {
              //history.replaceState( {item: $item.data('value'), index: _index}, $item.data('value'), $item.data('url') );
              //console.log("REPLACE 4: " + hashlink);
              VP.helpers.updateState($item.data('value'),_index,$item.data('value'),hashlink);
            }

            var $menuItem = $( _this.selectors.itemsWrapper ).children().eq( _index )[0];
            if( $item.data('type') === 'article-section' && $menuItem) {
              _this.viewItem( $menuItem );
              locationsCtr++;
            } else if( $item.data('type') === 'breaker' && $menuItem) {
              _this.focusMenuItem( $menuItem );
            }

            $item = $b;
          }
        });
      });
    },

    // Handles the auto focus of the menu item when the content that is tied to it is in view
    focusMenuItem: function($el) {
      if( $el.length > 0 ) {
        // get last position
        var _this = this;
        var _itemPos = 0;
        var _lastPos = $( _this.selectors.itemsWrapper ).scrollTop();

        _this.isEngaged = true;

        //console.log("focusMenuItem:");
        //console.log($el);
        /* this.selectorItemsScroll is set to false on click for IE to disable
         * scrolling for story tracker menu. This fixes the menu jumping/flicker on IE.
         * SetTimeout re-enables scrolling so it update as the page scrolls.
         */
        if (_this.selectorItemsScroll === false) {
          return;
        }

        $( _this.selectors.itemsWrapper ).scrollTop(0);

        if( $el.prev().hasClass( _this.selectors.menuBreaker.replace( '.', '' ) ) ) {
          _itemPos = $el.prev().position().top;
        } else if( !$el.is(':first-child') ) {
          _itemPos = $el.position().top;
        }

        $( _this.selectors.itemsWrapper ).scrollTop(_lastPos);

        var _maxSpeed = _this.getMaxSpeed();

        if( VP.breakpoint.currentBreakpoint !== 'small' ) {
          $( _this.selectors.itemsWrapper ).stop().animate( { scrollTop: _itemPos }, _maxSpeed);
        }
      }
    },

    // Focus on a marker on the map
    focusMapMarker: function( selectedItemIndex ) {
      var _this = this;
      //console.log("focus map marker")
    
      if( _this.itemClicked ) {
        //console.log("not clicked return");
        return;
      }

      _this.isEngaged = true;

      // Update markers state (Will change the icon. Red if active, Grey if inactive)
      // Look for the marker with ID that matches selectedItemIndex
      $.each( _this.map.markers, function( index, marker ) {
        if (marker) {
          if( marker.id === selectedItemIndex ) {
            marker.setIcon( _this.map.icons.active );
            marker.setZIndex( 2 );

            // Focus the marker
            if (!_this.expanded) {  // PANNING IS TOO FAST, SKIP ON FULL MAP
              // the infowindow makes it pan automatically
             // _this.map.obj.panTo( marker.position );
            }
            _this.map.obj.setOptions({ maxZoom: 20 });

            _this.infowindowshow(marker);
            //if (VP.breakpoint.currentBreakpoint !== 'small') {  // commout out to make map zoom same as desktop
            if (!_this.expanded) {
              _this.map.obj.setZoom(_this.map.single_item_zoom);
            }
            //}            
          } else {
            marker.setIcon( _this.map.icons.inactive );
            marker.setZIndex( 1 );
          }
        }
      });

    },

    // This function will scroll the document to the selected item
    scrollToItem: function( item, breaker, addoffset ) {

      var _this = this;
      var _offset = 0;
      _this.isEngaged = true;

      _this.dock(); // dock the menu before caculating tops of items

      if (!addoffset) {
        addoffset = 0;
      }

      // console.log("[scrollToItem] addoffset: " + addoffset);

    
      if ($(".vp-story-tracker__items").css("position") != "relative") {
        _offset = 54;
      }

      breaker = breaker || false;
      if( !breaker ) {
        $obj = $( '#' + _this.selectors.article.replace( '.', '' ) + '--item-' + item );
        _offset = 100;
      } else {
        $obj = $( _this.selectors.breaker ).eq(item);
      }

      $sbuttons = $(".vp-sortbuttons.fixed");
      if ($sbuttons.length == 1 && $sbuttons.hasClass("bottom")) {
        _offset = $sbuttons.height() + 20;
      }

      if (_this.expanded) { // TEMP FIX, MIGHT NEED TO ADJUST FOR CONDITIONS
        _offset = 10;
        if ( $(".vp-sortbuttons.fixed.top").length) {
          _offset +=  $(".vp-sortbuttons.fixed.top").height();
        }

        if ( $(".vp-quicklinks--docked").length) {
          _offset +=  $(".vp-quicklinks--docked").height();
        }
      }

      // console.log("[scrollToItem] _offset: " + _offset);


      var _top = $obj.offset().top - VP.nav.wrapper.outerHeight() - _offset;

      _top = _top + addoffset;
      _this.itemClicked = true;

      var _maxSpeed = _this.getMaxSpeed(_top);

      if (_this.hashInit) {
        _maxSpeed = 0;
      }

      if (_this.isIE11) {
        $( "html, body" ).scrollTop(_top);
        _this.itemClicked = false;
      } else {
        $( "html, body" ).animate( { scrollTop: _top + "px" }, _maxSpeed, function() {
          _this.itemClicked = false;
        });
      }
    },

    getMaxSpeed: function( _goto ){
      var _this = this;
      _upperlimit = 2000;

   //   console.log("MAP CLICK: " + _this.mapClick);

      _max_height = Math.max( $(document).height(), $(window).height() );
      _max_speed = _max_height / 500;


      if( _max_speed < 200 ) {
        _max_speed = 500;
      }

      if ( _goto  && VP.helpers.isMobile()  && _this.mapClick) {
        _speedfactor = 5;
        // get mobile max speed
        _cscroll = $(document).scrollTop();
        _dist = Math.abs(_goto - _cscroll);
        _distspeed = Math.round(_dist/_speedfactor);

        // console.log("_max_speed: " + _max_speed);
        // console.log("_cscroll: " + _cscroll);
        // console.log("_dist: " + _dist);
        // console.log("_speedfactor: " + _speedfactor);

       // console.log("_distspeed: " + _distspeed);
        _max_speed = Math.max(_max_speed, _distspeed);
      //  console.log("_max_speed: " + _max_speed);

        if (_max_speed > _upperlimit) {
          _max_speed = _upperlimit;
        }
      }

      return _max_speed;
    },

    // Triggered when the browser's back button is clicked so it will scroll with animation to the selected item
    popstate: function() {
      var _this = this;

      window.onpopstate = function( event ) {
        if ( event.state && event.state.item !== 0 ) {
          _this.focusMapMarker( event.state.item - 1 );
          _this.scrollToItem( event.state.item );
        }
      };
    },

    // This is important so that the Story Tracker Module is always on top and to group all the story items and put it in one wrapper
    updateModuleArrangement: function() {
      var _this = this;
      var $firstItem = null;

      // Get the parent of the first article module
      var $firstArticle = $( _this.selectors.article ).first().parent();

      // Get the parent of the first article breaker module
      var $firstBreaker = $( _this.selectors.breaker ).first().parent();

      //
      if( $firstBreaker.length === 0 || $firstArticle.index() < $firstBreaker.index() ) {
        $firstItem = $firstArticle;
      } else {
        $firstItem = $firstBreaker;
      }

      // Insert the story tracker before the parent of the first article module
      _this.module.insertBefore( $firstItem );

      // Add a wrapper
      $( _this.selectors.storyItem ).wrapAll( '<div class="' + _this.selectors.wrapper.replace( '.', '' ) + '" />');

      // Insert intro inside the wrapper
      $intro = $('.vp-module-intro-location').parent();
      $intro.insertBefore( _this.module );

      // Insert quicklinks after intro location
       $ql = $(".vp-quicklinks__wrapper");

       if ($ql.length) {
        $ql.insertAfter($intro);
       }

       // related items placement
       VP.modifiers.relatedfirst();
    },
  };
})(jQuery);
